<script context="module" lang="ts">
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

  export const updateProfileApi = async function (userInfo) {
    return HttpPromise({
      method: "PUT",
      url: "/api/retailer/user",
      data: {
        user: {
          first_name: userInfo.first_name,
          last_name: userInfo.last_name,
          email: userInfo.email,
          phone: userInfo.phone,
        },
      },
    });
  };

  export const updatePasswordApi = async function (accountInfo) {
    return HttpPromiseWithEntireResponse({
      method: "PUT",
      url: "/api/retailer/user/password",
      data: {
        user: {
          password: accountInfo.newPass,
          password_confirmation: accountInfo.newPassConfirm,
        },
      },
    });
  };
</script>
